var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagearrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.89909 9.39714L1.39909 16.8971C1.29246 16.9965 1.15143 17.0506 1.0057 17.048C0.859977 17.0455 0.720938 16.9864 0.617878 16.8834C0.514818 16.7803 0.455784 16.6413 0.453213 16.4955C0.450641 16.3498 0.504734 16.2088 0.604094 16.1021L7.70566 8.99964L0.604094 1.89714C0.504734 1.79051 0.450641 1.64947 0.453213 1.50375C0.455784 1.35802 0.514818 1.21898 0.617878 1.11592C0.720938 1.01286 0.859977 0.953831 1.0057 0.95126C1.15143 0.948688 1.29246 1.00278 1.39909 1.10214L8.89909 8.60214C9.00443 8.70761 9.0636 8.85058 9.0636 8.99964C9.0636 9.1487 9.00443 9.29167 8.89909 9.39714Z",
    fill: "#45852E",
    stroke: "#45852E",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagearrow);
export default __webpack_public_path__ + "static/media/page arrow.20b7ec0d5e39cde50e74b8b84ac2c0ff.svg";
export { ForwardRef as ReactComponent };